
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection/v2/[username]",
      function () {
        return require("private-next-pages/collection/v2/[username].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collection/v2/[username]"])
      });
    }
  